import Delete from './Delete/Delete';
import Get from './Get/Get';
import Patch from './Patch/Patch';
import Post from './Post/Post';
import Put from './Put/Put';
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, automId, automVersionId, getVariables) {
    switch (action.actionName) {
        case types.DELETE:
            return <Delete action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.GET:
            return <Get action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} getVariables={getVariables} />;
        case types.PATCH:
            return <Patch action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.POST:
            return <Post action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        case types.PUT:
            return <Put action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}
                showAlert={showAlert} automVersionId={automVersionId} />;
        default:
            break;
    }
}

export default Actions;

